// "Is it one of these?" (CS Ops 2.6) — the escalation tickets already on this order, above the
// raise button. Informational only: raising a new escalation is never blocked.
import { Alert, Space, Tag, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { ExistingTicket, fetchExistingTickets } from "../logistics.api";

interface Props {
  leadId?: string | null;
  poNumber?: string | null;
  issueType?: string | null;
}

const ExistingTicketsBanner: React.FC<Props> = ({ leadId, poNumber, issueType }) => {
  const [tickets, setTickets] = useState<ExistingTicket[]>([]);

  useEffect(() => {
    let cancelled = false;
    fetchExistingTickets({ lead_id: leadId, po_number: poNumber, issue_type: issueType }).then(
      (rows) => {
        if (!cancelled) setTickets(rows);
      }
    );
    return () => {
      cancelled = true;
    };
  }, [leadId, poNumber, issueType]);

  if (tickets.length === 0) return null;
  const sameIssue = tickets.some((t) => t.same_issue);

  return (
    <Alert
      type={sameIssue ? "warning" : "info"}
      showIcon
      style={{ marginBottom: 16 }}
      message={
        sameIssue
          ? "A ticket for this issue already exists on this order"
          : "This order already has escalation tickets — is it one of these?"
      }
      description={
        <Space direction="vertical" size={6} style={{ width: "100%" }}>
          {tickets.map((t) => (
            <div key={t.deal_id}>
              <Space size={6} wrap>
                <Typography.Link href={t.deal_url} target="_blank" rel="noreferrer">
                  {t.title}
                </Typography.Link>
                <Tag color={t.closed ? "default" : "orange"}>
                  {t.closed ? `Closed · ${t.stage ?? ""}` : t.stage}
                </Tag>
                {t.same_issue && <Tag color="red">Same issue</Tag>}
              </Space>
              <Typography.Text type="secondary" style={{ display: "block", fontSize: 12 }}>
                {t.reasons || "—"} · RCA: {t.rca || "—"} · Resolution: {t.resolution || "—"}
              </Typography.Text>
            </div>
          ))}
          <Typography.Text type="secondary" style={{ fontSize: 12 }}>
            Open a ticket to update it in Kylas, or raise a new escalation below if it is a different
            problem.
          </Typography.Text>
        </Space>
      }
    />
  );
};

export default ExistingTicketsBanner;
